import { render } from "./App.vue?vue&type=template&id=8d60eb58"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8d60eb58&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__